// src/components/Footer.jsx
import React from 'react';
import './Footer.css';

import logo from '../images/bblogo.png';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer__container">
        <div className="footer__info">
          <h3>Bright Beginning Elementary School</h3>
          <p><strong>Location:</strong> Khadjia Market, Ahalia, Harimpur, Uttara, Dhaka, Bangladesh</p>
          <p><strong>Email:</strong> bbeschool2019@gmail.com</p>
          <p><strong>Phone:</strong> +880 13 3514 1919</p>
        </div>

        <div className="footer__logo">
          {/* Replace src with your actual logo path */}
          <img src={logo} alt="Bright Beginning School Logo" />
        </div>
      </div>

      <div className="footer__bottom">
        <p>© {new Date().getFullYear()} Bright Beginning School. All rights reserved.</p>
      </div>
    </footer>
  );
}
